import PromoHero from './PromoHero';

export default PromoHero;
